
import { Component, Vue, Prop } from 'vue-property-decorator';
import ChatContentHistory from '@/components/chat/chatContentHistory.vue';
import { Dialog } from 'vant';
import {getChatHistoy } from '@/apis/message/message';
import i18n from '@/lang';

@Component({
  components: {
    ChatContentHistory,
  },
})
export default class ChatHistory extends Vue {
  private groupId: string | (string | null)[] = '';
  private friendid: string | (string | null)[] = '';
  private messageData: Array<any> = [];

  mounted() {
    this.$router.onReady(() => {
      this.friendid = this.$route.query.friendid;
      if (this.friendid) {
        this.getChatHistoyList(this.friendid);
      } else {
        Dialog.alert({
          title: 'error',
          message:  i18n.t('message.获取用户ID失败') as string,
          showCancelButton: false,
          beforeClose: () => {
            this.$router.back();
          },
        });
      }
    });
  }
  async getChatHistoyList(friendid:any): Promise<void>{
    const res = await getChatHistoy(friendid)
    this.messageData = res
  }
}
